import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-complete-account-setup-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './complete-account-setup.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class CompleteAccountSetupTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<CompleteAccountSetupTemplateData>;
}

export type CompleteAccountSetupTemplateData = {
  title: string;
  p1: string;
  p2: string;
  button_link: string;
  button_text: string;
  p3: string;
  footer: string;
  support_email: string;
};

export const CompleteAccountSetupTemplateMocks: CompleteAccountSetupTemplateData[] = [
  {
    title: 'Hello 👋',
    p1: "We've saved your company account and it's waiting for you!",
    p2: 'Recruitee is a leading Talent Acquisition Platform, designed for recruiters and hiring managers alike.',
    button_link: 'http://recruitee.com',
    button_text: 'Claim it now',
    p3: "If there's anything we can do to help, reply to this email and let us know.",
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
